import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppProvider from "./AppProvider";
import SignInPage from "./pages/signin/SignInPage";
import MainPage from "./pages/main/MainPage";
import SignUpPage from "./pages/signup/SignUpPage";
import AccessDeniedPage from "./pages/denied";
import Queue from "nq-js";
import RedirectPage from "./pages/RedirectPage";
import TestPage from "./pages/TestPage";
import TenantPage from "./pages/TenantPage";
import AboutUsPage from "./pages/about-us/AboutUsPage";
import ContactUsPage from "./pages/contact-us/ContactUsPage";
import JobPortalListPage from "./pages/job-portal/JobPortalListPage";
import JobDescription from "./pages/job-portal/JobDescription";
import ApplicationStatusList from "./pages/application-status/ApplicationStatusList";
import ApplicationFormPage from "./pages/application-form/ApplicationFormPage";
import CollectionFormPage from "./pages/collection-form/CollectionFormPage";
import ApplicationStatusForm from "./pages/application-form/ApplicationStatusForm";
import LandingPage from "./pages/landingpage/LandingPage";
import ClientPage from "./pages/clientpage/ClientPage";
import OptionCardsPage from "./pages/OptionCards/OptionCardsPage";
import WalkInFormPage from "./pages/application-form/walk-in/WalkInFormPage";
import VideoUpload from "./pages/about-us/VideoUpload";
import OthersPage from "./pages/others/OthersPage";
import ExpiredPage from "./pages/expired/ExpiredPage";
import ForgotPasswordPage from "./pages/forgot-password/ForgotPasswordPage";
import ForgotPassFormPage from "./pages/forgot-password/form/ForgotPassFormPage";

Queue.setUrl("https://api.innque.com/v1");
Queue.setApplicationId("lgs");

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/test" element={<TestPage />} />
          <Route path="/" element={<LandingPage />} />
          <Route path="/optioncard" element={<OptionCardsPage />} />
          <Route path="/clientpage" element={<ExpiredPage />} />
          {/* <Route path="/clientpage" element={<ClientPage />} /> */}
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signin/:isWalkIn" element={<SignInPage />} />
          <Route path="/signin/:master" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/signup/:isWalkIn" element={<SignUpPage />} />
          <Route path="/redirect/:id" element={<RedirectPage />} />
          <Route path="/app" element={<TenantPage />} />s
          <Route path="/*" element={<MainPage />} />
          <Route path={"/denied"} element={<AccessDeniedPage />} />
          {/* Portal */}
          <Route path={"/aboutus"} element={<AboutUsPage />} />
          <Route path={"/upload"} element={<VideoUpload />} />
          <Route path={"/contact"} element={<ContactUsPage />} />
          <Route path={"/jobportal"} element={<JobPortalListPage />} />
          <Route
            path={"/jobportal/:isWalkIn"}
            element={<JobPortalListPage />}
          />
          <Route
            path={"/job-description/:collectionname/:id"}
            element={<JobDescription />}
          />
          <Route
            path={"/application-form/:name"}
            element={<ApplicationFormPage />}
          />
          <Route
            path={"/job-list/application-form/:selected"}
            element={<ApplicationFormPage />}
          />
          <Route
            path={"/application-form/online_applicants"}
            element={<ApplicationFormPage />}
          />
          <Route path={"/forgot-password"} element={<ForgotPasswordPage />} />
          <Route
            path={"/password-reset/:sessionId"}
            element={<ForgotPassFormPage />}
          />
          <Route path={"/others"} element={<OthersPage />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
